import { useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import DocumentMeta from "react-document-meta";

import Layout from "../Layout";
import { cuesApi } from "../imports";
import { H2RButton } from "../imports";
import useGetMediaLocation from "./hooks/useGetMediaLocation";
import randomatic from "randomatic";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";

export default function Media() {
	// const [importing, setImporting] = useState(-1);
	let { projectId } = useParams();

	const selectedProject = useSelector(
		(state) => state.main.projects?.[projectId]
	);
	const mediaLocation = useGetMediaLocation();
	const media =
		useSelector((state) => state.main?.projects?.[projectId]?.media) || [];

	const meta = {
		title: `Media - ${selectedProject?.name}`,
	};

	const handleUpdateMediaName = (filename, newName) => {
		return cuesApi.updateMediaFile(projectId, filename, {originalname: newName})
	}

	if (selectedProject === undefined) {
		return null;
	} else {
		return (
			<DocumentMeta {...meta}>
				<Layout>
					<section className={`mx-5 my-5 flex flex-col flex-1 overflow-auto`}>
						<div className="mt-6 flex flex-col">
							<div className="grid grid-cols-3">
								<AddMedia />
								<AddMediaSequence />
							</div>
							{media.map((item) => {
								// if (item.filename === undefined) return null;
								if(item.partOf && (item.originalname !== item.firstFile)) return null

								// Remove any .html files that were imported
								if (item.mimetype === "text/html") return null

								return (
									<div
										key={item.filename}
										className="mx-2 my-2 px-2 py-2 flex justify-start items-center space-x-4 bg-gray-800 rounded group"
									>
										{(item.mimetype?.includes("mp4") ||
											item.mimetype?.includes("webm")) && (
											<video
												className="h-28 w-80 bg-contain bg-no-repeat bg-center rounded border border-gray-700"
												src={`${mediaLocation}${item.filename}`}
												controls={true}
											></video>
										)}

										{item.mimetype?.includes("audio") && (
											<audio
												className="h-10 w-80 bg-contain bg-no-repeat bg-center rounded border border-gray-700"
												src={`${mediaLocation}${item.filename}`}
												controls={true}
											></audio>
										)}

										{item.mimetype?.includes("image") && (
											<div
												className="h-28 w-80 bg-contain bg-no-repeat bg-center rounded border border-gray-700"
												style={{
													backgroundImage: `url(${mediaLocation}${item.filename})`,
												}}
											></div>
										)}
										{/* {item.mimetype?.includes("pdf") && (
											<div className="h-28 w-80 flex items-center justify-center font-semibold bg-contain bg-no-repeat bg-center rounded border border-gray-700">
												PDF
											</div>
										)} */}

										<div className="pr-4 w-full flex justify-between items-center space-y-1 ">
											<span className="text-sm text-gray-400">
											{item.partOf && '[Sequence] '}
											<span
												contentEditable
												suppressContentEditableWarning={true}
												onBlur={(e)=>{
													if(!e.target.innerText) {
														return e.target.innerText = item.originalname
													}
													return handleUpdateMediaName(item.filename, e.target.innerText)
												}}
												onKeyDown={(e)=>{
													if (e.key === 'Escape') {
														e.target.innerText = ''
														return e.target.blur() 
													}
													else if (e.key === 'Enter') {
														// e.preventDefault()
														// if(!e.target.innerText) {
														// 	return e.target.innerText = item.originalname
														// }
														// handleUpdateMediaName(item.filename, e.target.innerText)

														return e.target.blur()
													}
												}}
												className="p-1 focus:outline-none focus:ring rounded"
												>{item.originalname}</span>
												<FontAwesomeIcon className="ml-2 opacity-0 group-hover:opacity-100 transition-opacity" icon={faPencil} />
											</span>

											<H2RButton
												onClick={() =>
													cuesApi.removeFile(projectId, item.filename)
												}
												text="Remove"
												colour="dark"
												size="small"
												css=""
											/>
											{/* <span className="text-xs text-red-500">Delete</span> */}
										</div>
									</div>
								);
							})}
						</div>
						{/* {Array.map((item) => {
							return (
								<span className="m-2 p-2 w-full bg-gray-800 text-center text-gray-400 rounded animate-pulse">
									Importing...
								</span>
							);
						})} */}
					</section>
				</Layout>
			</DocumentMeta>
		);
	}
}

export const AddMedia = () => {
	const [importing, setImporting] = useState(false);
	let { projectId } = useParams();

	const fileUpload = (e) => {
		e.preventDefault();
		let array = Array.from(e.target.files);

		array.forEach(async (file) => {
			setImporting(true);
			const formData = new FormData();
			formData.append("file", file);

			await cuesApi.importFile(projectId, formData);

			return setImporting(false);
		});
	};
	return (
		<>
			<form className="col-span-2">
				<label className="h-16 mx-2 my-2 flex flex-col justify-center items-center text-center cursor-pointer bg-gray-900 border-2 border-gray-800 rounded hover:border-gray-700 hover:bg-gray-800">
					<span className="text-sm text-gray-400 font-semibold">
						Add new image, or video
					</span>
					<span className="pt-1 text-xs  text-gray-600 ">
						PNG, JPG, GIF, SVG, WebP, MP4, WebM, MP3 or WAV
					</span>
					<input
						className="opacity-0 h-0"
						type="file"
						name="file"
						accept="image/*, video/mp4, video/webm, audio/mpeg, audio/mp3, audio/wav"
						onChange={fileUpload}
						multiple
					/>
				</label>

				{/* <button type="submit">Upload</button> */}
			</form>
			{importing && (
				<span className="col-span-3 row-start-2 py-4 mx-2 mb-2 bg-gray-800 text-xs text-center uppercase animate-pulse">
					Importing...
				</span>
			)}
		</>
	);
};

export const AddMediaSequence = () => {
	const [importing, setImporting] = useState(false);
	let { projectId } = useParams();

	const fileUpload = async (e) => {
		e.preventDefault();
		let array = Array.from(e.target.files);
		const firstFile = e.target.files[0].name
		const partOf = randomatic("A0", 10)

		setImporting(true);
		const formData = new FormData();

		array.forEach((file) => {
			formData.append("files[]", file);
		});

		try {
			await cuesApi.importFileSequence(projectId, formData, partOf, firstFile, (progress) => {
				console.log('PROGRESS', progress)
			});
			setImporting(false);
		  } catch (error) {
			console.error("Error importing files:", error);
			setImporting(false);
		  }


		// array.forEach(async (file) => {
		// 	const formData = new FormData();
		// 	formData.append("file", file);

		// 	await cuesApi.importFileSequence(projectId, formData, partOf, firstFile);

		// 	return setImporting(false);
		// });
	};
	return (
		<>
			<form className="">
				<label className="h-16 mx-2 my-2 flex flex-col justify-center items-center text-center cursor-pointer bg-gray-900 border-2 border-gray-800 rounded hover:border-gray-700 hover:bg-gray-800">
					<span className="text-sm text-gray-400 font-semibold">
						Add new image sequence
					</span>
					<span className="pt-1 text-xs  text-gray-600 ">
						PNG files
					</span>
					<input
						className="opacity-0 h-0"
						type="file"
						name="file"
						accept="image/png"
						onChange={fileUpload}
						multiple
					/>
				</label>

				{/* <button type="submit">Upload</button> */}
			</form>
			{importing && (
				<span className="col-span-3 row-start-2 py-4 mx-2 mb-2 bg-gray-800 text-xs text-center uppercase animate-pulse">
					Importing...
				</span>
			)}
		</>
	);
};
